import * as CryptoJS from "crypto-js";

export const encryptIntoHash = string => {
  let obj = CryptoJS.AES.encrypt(string, "sexret");
  return obj.toString();
};
export const decryptHash = hash => {
  var bytes = CryptoJS.AES.decrypt(hash, "sexret");
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const CATEGORIES = [
  { id: "1", name: "Programming" },
  { id: "2", name: "Design" },
  { id: "3", name: "Virtual Assistant" },
  { id: "4", name: "Product" },
  { id: "5", name: "Project Management" },
  { id: "6", name: "Data Entry" },
  { id: "7", name: "Content Copy Writing" },
  { id: "8", name: "Digital Marketing" },
  { id: "9", name: "Customer Support" },
  { id: "10", name: "Seo" }
];
